import React from 'react';

import { DetailPageLayout } from 'src/components/common';

import { InitialBillingRulesCVAdmin } from './InitialBillingRulesCVAdmin/InitialBillingRulesCVAdmin';

export const InitialBillingRulesPage: React.FC = () => {
  return (
    <DetailPageLayout titleContent="Initial Billing Rules">
      <InitialBillingRulesCVAdmin />
    </DetailPageLayout>
  );
};
